<template>
	<v-container class="noMargin">		
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1">		      
			<v-flex lg12>
				<div class="pageTitle">
					<h2>INSTALLATION COSTS</h2>					
				</div>	
                <v-btn @click.prevent="fncUpdateBase" class="elevation-5" color="info"><i class="material-icons">add</i>UPDATE BASE INCREMENT</v-btn>        
				<v-btn @click.prevent="fncAddTier" class="elevation-5" color="info"><i class="material-icons">add</i>ADD INSTALLATION TIER</v-btn>				
			</v-flex>
		</v-layout>		
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex'; 	

	export default {
		name: 'InstallationHeader',
		data () {
			return {			
				
			}		
		},
        methods: {
          fncUpdateBase() {
            this.$store.dispatch('fncGetBasePriceModal');
          },
			fncAddTier() {
				var modalDetails = { title: 'Add Installation Tier', component: 'modal-tier-add', mstate: true, params: {} };			
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          }
		},
		computed: {
			...mapGetters([			
				'objAuthorize'			
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>